import axios from 'axios';

const apiClient = axios.create({
  baseURL: '/api',
  timeout: 60000,
});

// 上传文件
export const uploadFiles = (formData) =>
  apiClient.post('/upload', formData);

// 查询解析状态
export const getAnalysisStatus = (taskId) =>
  apiClient.get(`/analysis_status/${taskId}`);

// 计算报价
export const calculateQuote = (data) =>
  apiClient.post('/calculate', data);

// 获取材料树
export const getMaterials = () =>
  apiClient.get('/materials');

// 获取表面处理列表
export const getSurfaceTreatments = () =>
  apiClient.get('/surface_treatments');

// 获取公差等级
export const getToleranceGrades = () =>
  apiClient.get('/tolerance_grades');

// 提交校准数据
export const getAIStatus = () => apiClient.get('/ai/status');

export const submitCalibration = (data) =>
  apiClient.post('/calibrate', data);

// 获取校准统计
export const getCalibrationStats = () =>
  apiClient.get('/calibration_stats');
